import { PreformCatalogResponse } from '@/shared/state/api/swagger';

export const selectPreforms = (preforms: PreformCatalogResponse[] = []) => {
	return preforms.map((preform) => ({
		value: preform.id,
		label: preform.name,
	}));
};
